<div oui-dialog-title>
  Envoyer un mail
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>
<oui-dialog-content>
  <div class="flex-vertical flex-start gap-24">
    <oui-textfield type="email" label="De" [control]="mailFromControl" class="width-100pc"> </oui-textfield>
    <oui-textfield type="text" label="Objet" [control]="subjectControl" class="width-100pc"> </oui-textfield>
    <oui-textarea label="Message" [control]="messageControl" class="width-100pc"> </oui-textarea>
  </div>
</oui-dialog-content>
<oui-dialog-actions>
  <oui-button type="text" oui-dialog-close> Annuler </oui-button>
  @if (!isSending) {
    <oui-button
      type="contained"
      (click)="onSendEmailClick()"
      [disabled]="!subjectControl.valid || !messageControl.valid"
      >
      Envoyer
    </oui-button>
  } @else {
    <div class="flex-horizontal align-self-center">
      <oui-loading size="small"></oui-loading>
    </div>
  }
</oui-dialog-actions>
